export default __webpack_public_path__ + "static/media/raiffeisen_l1.b3acce88.png";